import request from '@/utils/request'

let getProductList=()=>request.get('/api/product/listProductName')
// 上传imei
let agentUpload=(data)=>request.post('/api/lock/lock',data,{'content-type':'multipart/form-data'})
let agentUploadSingle=(data)=>request.post('/api/lock/singleLock',data,{'content-type':'application/json'})

let getUploadList=(data) => request.post('/api/lock/getUploadLogs', data)

export default {
  getProductList,
  agentUpload,
  agentUploadSingle,
  getUploadList
}